import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getCookie } from '../../utils/utils';
import AuthStore from '../../store/auth/AuthStore';
import UserStore from '../../store/UserStore';

const PrivateLayout: React.FC = () => {
  const [fetching, setFetching] = useState(true);

  useEffect(() => {
    async function getUserData() {
      if (getCookie('AccessToken')) {
        UserStore.getUserData();
        setFetching(false);
      }
      else {
        await AuthStore.refresh();
        setFetching(false);
      }
    }
  
    getUserData();
  })

  if (fetching)
    return <h1>Loading...</h1>
  else
    return UserStore.id ? <Outlet /> : <Navigate to='/auth' />;
}

export default PrivateLayout;